import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PrintPdfDialogData, PrintPdfTargetType, PrintPdfEntities } from './print-pdf.model';
import { AppConfig } from 'src/app/app.config';

@Component({
    selector: 'app-print-pdf-dialog',
    templateUrl: './print-pdf-dialog.component.html',
    styleUrls: ['./print-pdf-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PrintPdfDialogComponent implements OnInit {
    public mobile: boolean = false;
    public targetId!: string;
    public targetType!: PrintPdfTargetType;
    public selectedBid: any;
    public IsOwnTendering: boolean = false;

    public taskEntities: Array<PrintPdfEntities> = [
        { entity: 'taskTimestamp', flagValue: 4, checked: true, blah: 'task.taskTimestamp.schedule' },
        { entity: 'taskCostAccountings', flagValue: 64, checked: true, blah: 'task.costAccountings.costAccountings' },
        { entity: 'taskCompany', flagValue: 1, checked: true, blah: 'task.companyComponent.companies' },
        { entity: 'taskPerson', flagValue: 2, checked: true, blah: 'task.personComponent.people' },
        { entity: 'taskExternalPerson', flagValue: 128, checked: true, blah: 'task.personComponent.externalPersons.tabHeader' },
        { entity: 'taskSpecificProperties', flagValue: 8, checked: true, blah: 'task.technicalDetails.technicalDetails' },
        { entity: 'taskUnits', flagValue: 16, checked: true, blah: 'task.unit.units' },
        { entity: 'taskWorkSafety', flagValue: 32, checked: true, blah: 'worksite.worksiteWorksafetyDocument.risks.risks' }
    ];

    public tenderingEntities: Array<PrintPdfEntities> = [
        { entity: 'tenderingLocation', flagValue: 1, checked: true, blah: 'task.basicInformation.location' },
        { entity: 'tenderingTimestamp', flagValue: 2, checked: true, blah: 'task.taskTimestamp.schedule' },
        { entity: 'tenderingCompany', flagValue: 4, checked: true, blah: 'task.companyComponent.companies' },
        { entity: 'tenderingPerson', flagValue: 8, checked: true, blah: 'task.personComponent.people' },
        { entity: 'tenderingComments', flagValue: 16, checked: true, blah: 'tendering.cards.comments' },
        { entity: 'tenderingAttachments', flagValue: 32, checked: true, blah: 'tendering.attachment.attachments' },
        { entity: 'tenderingInformation', flagValue: 64, checked: true, blah: 'tendering.details.tenderingInformation.cardHeader' }
    ];

    public targetEntities: Array<PrintPdfEntities> = [];

    constructor(
        private dialogRef: MatDialogRef<PrintPdfDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private dialogData: PrintPdfDialogData,
        private config: AppConfig) { }

    ngOnInit() {
        this.mobile = this.dialogData.mobile;
        this.targetId = this.dialogData.targetId;
        this.targetType = this.dialogData.targetType;
        this.selectedBid = this.dialogData.selectedBid;
        this.IsOwnTendering = this.dialogData.isOwnTendering;
        this.getTargetEntities(this.targetType);
    }

    submit() {
        // Calculate the flag value for  entities
        let flagValue = this.calculateEntityFlagValue();
        let url;

        if (this.targetType === 'Task') {
            url = this.config.backendIwmUri + `/WebUI/File/DownloadPdf?taskId=${this.targetId}&taskEntity=${flagValue}`;
        }

        if (this.targetType === 'Tendering') {
            url = this.config.backendIwmUri + `/WebUI/TenderingFile/DownloadPdf?tenderingId=${this.targetId}&tenderingEntity=${flagValue}`;

            if (this.selectedBid && this.tenderingEntities.find(e => e.entity === 'tenderingBids')['checked']) {
                url += `&bidderId=${this.selectedBid.BidderCompanyId}&bidId=${this.selectedBid.Id}`;
            }
        }

        window.open(url, '_blank');
        this.dialogRef.close();
    }

    getTargetEntities(targetType) {
        switch (targetType) {
            case 'Task':
                this.targetEntities = [...this.taskEntities];
                break;
            case 'Tendering':
                if (this.selectedBid && this.IsOwnTendering) {
                    this.tenderingEntities.push({ entity: 'tenderingBids', flagValue: 512, checked: false, blah: 'tendering.tenderingBidList.descriptionTooltipHeader' })
                }
                this.targetEntities = [...this.tenderingEntities];
                break;
            default:
                this.targetEntities = [];
                break;
        }
    }

    private calculateEntityFlagValue(): number {
        let returnValue = 0;

        this.targetEntities.forEach(entity => {
            if (entity.checked) {
                returnValue += entity.flagValue;
            }
        })

        return returnValue;
    }
}
